import { errorMessages } from '@/lib/errors';
import axios from 'axios';
import { toast } from 'react-toastify';

const API_BASE_URL = '/api/';

const httpClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000, // 30 seconds timeout
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

// Response Interceptor
httpClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      if (
        error.response.status === 401 &&
        !location.pathname.includes('/login') &&
        error.response.data.message !== errorMessages.invalidOTP
      ) {
        toast.error('Not authorized, please login again');
        location.href = `/login?previous=${location.href}`;
      }
      return Promise.reject(error.response.data);
    }
    return Promise.reject(error);
  }
);

// API Wrapper
export const api = {
  get: (url: string, params = {}, config = {}) =>
    httpClient.get(url, { params, ...config }),
  post: (url: string, data = {}, config = {}) =>
    httpClient.post(url, data, config),
  put: (url: string, data = {}, config = {}) =>
    httpClient.put(url, data, config),
  delete: (url: string, config = {}) => httpClient.delete(url, config),
};

export default httpClient;
